export default __webpack_public_path__ + "static/media/signup-gmail-button.87b0c601.svg";